import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "@/lib/analytics";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import { ClosingReminder } from "@/components/ClosingReminder";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackPageView(pathname);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:bg-hacienda-terracotta focus:text-white focus:px-4 focus:py-2 focus:rounded-full">Skip to content</a>
      <AnnouncementBar />
      <Header pathname={pathname} />
      <main id="main-content" className="flex-grow pb-16 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <ClosingReminder />
      <MobileActionBar />
    </div>
  );
};

export default Layout;
